import { colors } from "@areahub/theme";
const darknessArr = [
  "50",
  "100",
  "200",
  "300",
  "400",
  "500",
  "600",
  "700",
  "800",
  "900",
];

function splitColor(color: string) {
  return color.split(".");
}

function getDarknessIdx(darkness?: string) {
  return darkness ? darknessArr.indexOf(darkness) : -1;
}

/**
 * Returns a color that's one shade darker than the input
 * @param color A color of the form `color.###` e.g `blue.50`
 * @returns A color 1 shade darker, e.g. `blue.100`
 */
export function oneDarker(color: string) {
  const [shade, darkness] = splitColor(color);
  const idx = getDarknessIdx(darkness);
  return idx > 0 && idx < darknessArr.length - 1
    ? `${shade}.${darknessArr[idx + 1]}`
    : "black";
}

/**
 * Returns a color that's one shade lighter than the input
 * @param color A color of the form `color.###` e.g `blue.100`
 * @returns A color 1 shade lighter, e.g. `blue.50`
 */
export function oneLighter(color: string) {
  const [shade, darkness] = splitColor(color);
  const idx = getDarknessIdx(darkness);
  return idx > 1 && idx < darknessArr.length
    ? `${shade}.${darknessArr[idx - 1]}`
    : "white";
}

/**
 * Returns a color that's a light shade (.100) of the input
 * @param color A color of the form `color.###` e.g `blue.100`
 * @returns The light color, e.g. `blue.100`
 */
export function getLight(color: string) {
  const [shade, _darkness] = splitColor(color);
  return `${shade}.100`;
}

export function getColorKey(
  color: string | undefined,
  fallback: string = "blue",
) {
  return colors[
    color !== undefined
      ? (color as keyof typeof colors)
      : (fallback as keyof typeof colors)
  ];
}
